module.exports = __webpack_public_path__ + "static/media/pin.5588985a.svg";